export default {
  bc () {
    return this.background || (this.dark ? 'rgba(0,0,0,0.8)' : 'rgba(255,255,255,0.8)')
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-professional/gadget/resources/computed.js